import { useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { IncomingOutgoingAmlContent, TransactionTypeEnum } from '@ui/src';
import { useAppSelector } from '@store';
import { useLazyGetTransactionAmlQuery } from '../store/services/customers';

const ProblemInternalTransactionAmlContentHOC = (): React.JSX.Element => {
  const { transactionId } = useParams();

  const {
    incoming: { aml },
  } = useAppSelector((state) => state.customersProblemTransactions);

  const [getIncomingAml, { isLoading }] = useLazyGetTransactionAmlQuery();

  const getIncomingAmlAction = useCallback(() => {
    getIncomingAml(transactionId as string);
  }, [transactionId]);

  useEffect(() => {
    if (!aml && transactionId) {
      getIncomingAmlAction();
    }
  }, [getIncomingAmlAction, aml, transactionId]);

  return (
    <IncomingOutgoingAmlContent
      isLoading={isLoading}
      aml={aml}
      transactionType={TransactionTypeEnum.INCOMING}
    />
  );
};

export default ProblemInternalTransactionAmlContentHOC;
